/**
 * Fixed synthetic store roster reused across the cross-store mock domains
 * (tickets, moderation, affiliates, webhooks, credit anomalies, data
 * requests, announcement audience preview) so the same "store" shows up
 * consistently across pages instead of every list inventing unrelated
 * names. (Failing charges no longer uses mocks: it is served by the real
 * GET /admin/billing/failing-charges endpoint.)
 */
export interface MockStoreRef {
  id: string
  name: string
  plan: string
}

export const MOCK_STORE_ROSTER: MockStoreRef[] = [
  { id: 'mock-store-01', name: 'Noor Abayas', plan: 'scale' },
  { id: 'mock-store-02', name: 'Desert Bloom Perfumes', plan: 'pro' },
  { id: 'mock-store-03', name: 'Riyadh Sneaker Club', plan: 'launch' },
  { id: 'mock-store-04', name: 'Al Salam Home Decor', plan: 'pro' },
  { id: 'mock-store-05', name: 'Falcon Fit Supplements', plan: 'scale' },
  { id: 'mock-store-06', name: 'Little Oasis Kids', plan: 'launch' },
  { id: 'mock-store-07', name: 'Gulf Coast Gadgets', plan: 'trial' },
  { id: 'mock-store-08', name: 'Sahara Skincare Co.', plan: 'pro' },
  { id: 'mock-store-09', name: 'Marina Pet Supplies', plan: 'launch' },
  { id: 'mock-store-10', name: 'Zayed Books & Stationery', plan: 'trial' },
  { id: 'mock-store-11', name: 'Coral Reef Swimwear', plan: 'scale' },
  { id: 'mock-store-12', name: 'Palm Grove Furniture', plan: 'pro' },
]
